import { GameCommunicationMessageType, IGameCommunicationProcessor, gameStateActions } from '@pp/core';
import { MWGameStatus } from '../../../store/slices/mwState/types';
import type { GameStore } from '../../../store/GameStore';
import { mwStateActions } from '../../../store/slices/mwState/slice';
import { MWTimings } from '../../../config/MWTimings';
import { MWSpecificEvents } from '../../../config/events';

import GameCustomEventService from '../../../utilities/GameCustomEventService';

export interface MegaWinMessage extends GameCommunicationMessageType {
  gameId: string;
  slot: {
    number: number;
    multiplier: number;
  };
}

export class GameCommunicationMegaWinProcessor implements IGameCommunicationProcessor {
  messageName = 'jackpotwheel_rng';

  process(message: MegaWinMessage, store: GameStore): void {
    const hasBets = store.getState().bets.betStack.length > 0;
    const isLoadedInActiveRound = store.getState().gameState.timer <= 0;

    if (message && (message?.value || message?.slot)) {
      let megaMultiplierTimer: NodeJS.Timeout | undefined,
        spinningTimer: NodeJS.Timeout | undefined,
        megaMultiplierValue: NodeJS.Timeout | undefined;

      let megaWinValue: { number: number; multiplier: number };
      if (message?.slot) {
        megaWinValue = message?.slot;
      }
      megaMultiplierValue = setTimeout(() => {
        store.dispatch(mwStateActions.setMegaWinValue(megaWinValue));
      }, MWTimings.MultiValueDisplayDelay);

      if (!isLoadedInActiveRound && hasBets) {
        megaMultiplierTimer = setTimeout(() => {
          store.dispatch(gameStateActions.setCurrentGameStatus(MWGameStatus.MEGA_MULTIPLIER));
        }, MWTimings.MultiValueDisplayDelay);

        spinningTimer = setTimeout(() => {
          store.dispatch(gameStateActions.setCurrentGameStatus(MWGameStatus.SPINNING));
        }, MWTimings.TrafficLightSpinningStatusVisibility);
      }
      GameCustomEventService.addGameEventListner(MWSpecificEvents.CLEAR_TIMERS, this.messageName, (e) => {
        clearTimeout(megaMultiplierValue);
        clearTimeout(megaMultiplierTimer);
        clearTimeout(spinningTimer);
        GameCustomEventService.removeGameEventListners(MWSpecificEvents.CLEAR_TIMERS, this.messageName);
      });
    }
  }
}
